import { Component, Input, OnInit } from '@angular/core';

import { NbMenuService, NbSidebarService } from '@nebular/theme';

import { AnalyticsService } from '../../../@core/utils/analytics.service';
import { AuthComponent } from '../../../pages/auth/auth.component';
import { AuthService } from '../../../@core/auth/auth.service';
import { UsageMetricsService } from '../../../pages/tenants/usage-metrics/usage-metrics.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

  @Input() position = 'normal';

  user: any;

  userMenu = [{ title: 'Log out' }];

  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              public authService: AuthService,
              private analyticsService: AnalyticsService,
              private usageMetricsService: UsageMetricsService) {
  }

  ngOnInit() {
    this.user = this.authService.userProfile();
    
    //Add option to change tenant in menu for admin role
    if(this.authService.hasRole('kw:admin')){
      this.userMenu.push({title: "Change Tenant"});
      this.userMenu.push({title: "Tenant Management"});
      this.userMenu.push({title: "Platform Config"});
      this.userMenu.push({title: "Tenant Detail"});
    }

    // Who can see usage metrics (kw:admin + a short staff list) is decided by the API.
    this.usageMetricsService.hasAccess().subscribe({
      next: allowed => {
        if (allowed && !this.userMenu.some(m => m.title === "Usage Metrics")) {
          this.userMenu.push({title: "Usage Metrics"});
        }
      },
      error: () => { /* no menu item if the check fails */ }
    });
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');

    return false;
  }

  toggleSettings(): boolean {
    this.sidebarService.toggle(false, 'settings-sidebar');

    return false;
  }

  goToHome() {
    this.menuService.navigateHome();
  }

  startSearch() {
    this.analyticsService.trackEvent('startSearch');
  }

  logOut() {
  }
}
